import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { FuelList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

import './styles.scoped.scss';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Gun',
    key: 'gun_name',
  },
  {
    name: 'Staff',
    key: 'all',
    formatter(props) {
      return <>{`${props.cashier_first_name} ${props.cashier_last_name}`}</>;
    },
  },
  {
    name: 'Shift',
    key: 'shift',
  },
  {
    name: 'Opening',
    key: 'opening_reading',
  },
  {
    name: 'Closing',
    key: 'closing_reading',
  },
  {
    name: 'Testing',
    key: 'testing_liters',
  },
  {
    name: 'Bowser',
    key: 'bowser_total',
  },
  {
    name: 'Liters Sold',
    key: 'litters_sold',
  },
  {
    name: 'Rate/Liter',
    key: 'price',
  },
  {
    name: 'Total amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.total_amount)}</>;
    },
  },
];

class FuelsSalesGunWiseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fuelSalesList: [],
      product_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    //this.getFuelSalesGunWise();
  }

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 6;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value });
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState({
          end_date: value,
          start_date: minStartDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  getFuelSalesGunWise = () => {
    services
      .getFuelSalesGunWise(this.state)
      .then((response) => {
        this.setState({
          fuelSalesList: response.data.data.results || [],
          count: response.data.data.count || 0,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  };
  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState({ limit: this.limitInput.current.value, offset: 1 }, () => {
      this.getFuelSalesGunWise();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getFuelSalesGunWise();
    });
  };
  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };
  resetFilter = () => {
    this.setState(
      {
        date: dayjs().format('YYYY-MM-DD'),
        loading: false,
        product_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        offset: 1,
        count: 0,
        fuelSalesList: [],
        limit: 20,
      },
      function () {
        //this.getFuelSalesGunWise();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true, offset: 1 }, function () {
      this.getFuelSalesGunWise();
    });
  };

  render() {
    const { fuelSalesList } = this.state;
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <h3> Fuels Sales Report </h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label> Fuel type:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  ></button>
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={fuelSalesList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: `Fuel Sales - Gun Wise - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Fuel Sales Report - Gun Wise',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['total_amount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: `Total liters -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['litters_sold'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportTesting: `Total testing liters -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['testing_liters'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportBowser: `Total bowser filling -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['bowser_total'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportSales: `Total sales -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['sales'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total testing liters: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList
                        .reduce((a, b) => a + (b['testing_liters'] || 0), 0)
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total bowser filling: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList
                        .reduce((a, b) => a + (b['bowser_total'] || 0), 0)
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total liters sold: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList
                        .reduce((a, b) => a + (b['litters_sold'] || 0), 0)
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      fuelSalesList
                        .reduce((a, b) => a + (b['total_amount'] || 0), 0)
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </section>
    );
  }
}

export { FuelsSalesGunWiseReport };
